const INITIAL_STATE = {
  data: {},
  errors: {},
}
	
const getDiscounts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_DISCOUNTS_CATALOG_SUCCESSFULY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_DISCOUNTS_CATALOG_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
	
export default getDiscounts;
	